import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './TagList.module.scss';

const TagList = ({ children, className }) => (
  <ul className={cn(styles.list, className)}>
    {children}
  </ul>
);

TagList.propTypes = {
  className: PropTypes.string,
};

TagList.defaultProps = {
  className: null,
};

export default TagList;
